module.exports = __webpack_public_path__ + "11_hair_gold.871b4a11.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/11_hair_gold.png
// module id = tdtB
// module chunks = 0